import { ProductTypeViewModel } from "./ProductTypeViewModel";

export interface SpecConstraintViewModel {
  id: number;
  key: string;
  displayName: string;
  valueType: SpecValueType;
  selectionMode?: SpecSelectionMode;
  productTypeId?: number;
  productTypeIds?: number[];
  productType?: ProductTypeViewModel | null;
  productTypes?: ProductTypeViewModel[] | null;
  allowedValues?: SpecAllowedValueViewModel[] | null;
  isDeleted?: boolean;
}

export interface SpecAllowedValueViewModel
{
    id: number;
    specConstraintId: number;
    specConstraint?: SpecConstraintViewModel | null;
    value: string;
    /** Admin-defined display order (lower shows first). */
    displayOrder?: number;
}

export enum SpecValueType {
  Number = 0,
  String = 1,
  Enum = 2,
}

export enum SpecSelectionMode {
  Single = 0,
  Multi = 1,
}